/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyWebexIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-webex" */ './utils').then((m) => m.WebexIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/webex/icon' },
);

const LazyWebexSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-webex-search-result" */ './utils').then(
			(m) => m.WebexSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/webex/search-result-icon' },
);

const LazyWebexIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-webex-borderless" */ './utils').then(
			(m) => m.WebexIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/webex/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const WebexIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyWebexIconComponent />
	</Suspense>
);

export const WebexSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyWebexSearchResultIconComponent />
	</Suspense>
);

export const WebexIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyWebexIconBorderlessComponent />
	</Suspense>
);
